import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AddAddress from './AddAddress';
import Status from '../Status';
import Modal from '../../Modal/Modal';
import StepByStep from '../../StepByStep';
import {
  ADD_ADDRESS_WIZARD,
  STATUS_NEW_ADDRESS_ADDED,
} from '../../../constants/sessionStorage';
import { storeInSessionStorage } from '../../../util/helpers/sessionStorageHelper';

const steps = [AddAddress, Status];

const AddAddressModal = ({ isOpen, onClose, page }) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');

  const handleNext = () => {
    if (!error) storeInSessionStorage(STATUS_NEW_ADDRESS_ADDED, true);
    onClose();
  };

  return (
    <Modal
      title="Add Address"
      size="sm"
      isOpen={isOpen}
      close={onClose}
      closeIconVisible
    >
      {page === 'address' ? (
        <StepByStep saveStepDisabled sessionScopeStep={ADD_ADDRESS_WIZARD}>
          {({ goStepForward, goStepBack }) =>
            steps.map((step) =>
              React.createElement(step, {
                handleBack: goStepBack,
                handleNext: goStepForward,
                handleClose: onClose,
                onButtonClick: onClose,
                hasError: !!error,
                text:
                  error || t('account.addresses.addAddressSuccessfulMessage'),
                backButtonText: t('common.ok'),
                setError,
              }),
            )
          }
        </StepByStep>
      ) : (
        <AddAddress
          onButtonClick={onClose}
          handleNext={handleNext}
          setError={setError}
        />
      )}
    </Modal>
  );
};

AddAddressModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  page: PropTypes.string,
};

export default AddAddressModal;
